import React, { useState, useEffect } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import amaxLogo from "../../images/amaxLogo.png";
import arrowNext from '../../images/arrowNext.svg'; // Ensure correct path to arrowNext

export const CoachStep1 = () => {

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [phonenumber, setPhonenumber] = useState('');
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);

  const navigate = useNavigate();
 
  useEffect(() => {
    // Restore data from sessionStorage
    const firstname_ = sessionStorage.getItem('firstname');
    const lastname_ = sessionStorage.getItem('lastname');
    const phonenumber_ = sessionStorage.getItem('phonenumber');
    if (firstname_) setFirstname(firstname_);
    if (lastname_) setLastname(lastname_);
    if(phonenumber_) setPhonenumber(phonenumber_);
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();

    // Basic validation
    if (!firstname || !lastname || !phonenumber) {
      setError('Please enter all the details!');
      setMsg(null);
      return;
    }

    setError(null);
     // Navigate to the second step with the form data
     //save the data in session
     sessionStorage.setItem("firstname",firstname);
     sessionStorage.setItem("lastname",lastname);
     sessionStorage.setItem("phonenumber",phonenumber);

     navigate('/coach/register/step2');
  };


  return (
    <div className="p-[20px] bg-black h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
          <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>
        <div className="flex flex-col gap-[50px] w-full">
          <div className="flex flex-col gap-[15px]">
            <h1 className="text-white text-[40px] leading-[95%] font-light uppercase">
              you&apos;re in <br /> get started
            </h1>
            <form onSubmit={handleSubmit} className="flex flex-col gap-[15px]">
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="First Name"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
              />
  
              <input
                type="text"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Last Name"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
              />
              <input
                type="tel"
                className="border border-white focus:outline-none rounded-[50px] bg-transparent text-white text-lg !leading-none p-[16px] font-normal placeholder:text-[#5d5d5d]"
                placeholder="Phone Number"
                value={phonenumber}
                onChange={(e) => setPhonenumber(e.target.value)}
              />

              {/* Display Error Message */}
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  {error}
                </p>
              )}

              {/* Display Success Message */}
              {msg && (
                <p className="text-green-500 text-sm mt-2">
                  {msg}
                </p>
              )}

              <button
                type="submit"
                className="bg-white size-[70px] rounded-full flex justify-center items-center hover:bg-white/50 transition-all duration-300 ml-auto mt-[10px]"
              >
                <img src={arrowNext} alt="arrow" className="object-contain" />
              </button>



            </form>
          </div>
        
        </div>
      </div>
    </div>
  );
};
